import { CategoriesActions, ECategoriesActions } from '../actions/categories.actions';
import { CategoriesState, initialCategoriesState, initialTagsState, TagsState } from '../states/tags.state';

export function categoriesReducer(
  state = initialCategoriesState,
  action: CategoriesActions
): CategoriesState {
  switch (action.type) {
    case ECategoriesActions.ListCategoriesSuccess: {
      return {
        ...state,
        categories: action.payload
      };
    }

    case ECategoriesActions.ListCategoriesFailure: {
      return {
        ...state,
        categories: []
      };
    }

    default:
      return state;
  }
}
